import { useState, useEffect } from "react";
import { toast } from "sonner";
import { adminApi, AdminHeader, EmptyState } from "@/lib/adminApi";

const AdminSubscribers = () => {
  const [data, setData] = useState(null);
  useEffect(() => { adminApi("/admin/signups").then(setData).catch((e) => toast.error(e.message)); }, []);
  if (!data) return <div className="text-[var(--text-secondary)]">Loading...</div>;

  const rows = [
    ...data.community_signups.entries.map((e) => ({ ...e, list: "Future Signals" })),
    ...data.book_waitlist.entries.map((e) => ({ ...e, list: "Book Waitlist" })),
  ].sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));

  return (
    <div>
      <AdminHeader title="Newsletter & Subscribers" subtitle={`${data.community_signups.count} Future Signals subscribers · ${data.book_waitlist.count} book waitlist`} testId="subscribers-heading" />
      {rows.length === 0 ? <EmptyState text="No subscribers yet" testId="subscribers-empty" /> : (
        <div className="bg-[var(--bg-card)] border-glow rounded-xl divide-y divide-[rgba(124,58,237,0.08)]" data-testid="subscribers-list">
          {rows.map((r) => (
            <div key={`${r.list}-${r.id}`} className="flex items-center justify-between px-5 py-3">
              <div>
                <p className="text-sm text-white">{r.email}</p>
                {r.first_name && <p className="text-xs text-[var(--text-secondary)]">{r.first_name}</p>}
              </div>
              <div className="flex items-center gap-4 text-xs text-[var(--text-secondary)]">
                <span className="text-[var(--accent-violet-light)]">{r.list}</span>
                <span>{r.created_at ? new Date(r.created_at).toLocaleDateString() : ""}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminSubscribers;
